import { restApiDP } from "@plannel/services/utils/rest-api";

const getNote = (data) => {
  return restApiDP.post("/api/dp-note", data);
};

const upsertNote = (data) => {
  return restApiDP.post("/api/dp-note/upsert", data);
}

const deleteNote = (data) => {
  return restApiDP.post("/api/dp-note/delete", data);
}

const dpNoteService = {
  getNote,
  upsertNote,
  deleteNote
};

export default dpNoteService;